// extracted by mini-css-extract-plugin
export default {"body":"MinMax_body__Yv2f2"};